import * as React from 'react';
import { createContext, useContext } from 'react';

const TwoPanelChatRouteContext = createContext<boolean>(false);

export const useIsTwoPanelChatRoute = (): boolean => useContext(TwoPanelChatRouteContext);

/* When mounted, signals that we're on a route that should show the two-panel
 * chat trigger. Consumed via the useIsTwoPanelChatRoute hook. */
export const TwoPanelChatRouteProvider = ({ children }: { children: React.ReactNode }) => (
  <TwoPanelChatRouteContext.Provider value={true}>{children}</TwoPanelChatRouteContext.Provider>
);
